import querystring from 'query-string'
import { FC, ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { stringBetween } from '../../features/news/utils/utils'

type ScreenshotModalLinkProps = {
  children?: ReactNode
  originalLink: string
  className?: string
}

export const ScreenshotModalLink: FC<ScreenshotModalLinkProps> = ({ originalLink, className, children }) => {
  const location = useLocation()
  // reverse the order of the screenshot and create a new link
  const target = `${location.pathname}/screenshots/${stringBetween(originalLink, 'shotModal=', '&').split(',').reverse().join(',')}`

  // Preserve the existing location.search (e.g. Market Explorer segments `s0marketIso`,
  // `s0visible`, axis/column state, Live Events selected games) and merge the
  // `shotModalIso` param from the analyst-link URL on top. Replacing `location.search`
  // wholesale here was the root cause of GR-1938: when the screenshot modal closed,
  // the surrounding page lost its segment/selection state.
  const mergedSearch = querystring.stringify({
    ...querystring.parse(location.search),
    shotModalIso: querystring.parse(originalLink).shotModalIso,
  })

  const newLocation = {
    ...location,
    pathname: target,
    search: mergedSearch,
  }

  return (
    <Link className={className} to={newLocation} state={{ ...(location.state as Record<string, unknown>), skipScrollToTop: true }}>
      {children}
    </Link>
  )
}
